export default __webpack_public_path__ + "static/media/panTech5Full.3db22146.png";